module.exports = __webpack_public_path__ + "static/media/32-5.e31b0658.mp3";